import { render, staticRenderFns } from "./MyColorPicker.vue?vue&type=template&id=49ebc43c&scoped=true"
import script from "./MyColorPicker.vue?vue&type=script&lang=js"
export * from "./MyColorPicker.vue?vue&type=script&lang=js"
import style0 from "./MyColorPicker.vue?vue&type=style&index=0&id=49ebc43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ebc43c",
  null
  
)

export default component.exports